import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';

export const FooterMenu3 = {
    computed: {
        ...mapState(vplSiteStore, ['menu'])
    },
    template: `
        <template v-if="this.menu.footer3" class="header__nav">
            <li v-for="menuItem in this.menu.footer3.ITEMS" :key="menuItem.TEXT">
                <a :href="menuItem.LINK">{{ menuItem.TEXT }}</a>
            </li>
            <button v-if="this.menu.top.EDIT_BUTTON" :onclick="this.menu.top.EDIT_BUTTON">Редактировать пункты меню</button>
        </template>
    `
}